
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { getAllDistrictBihar, getDistrict, getStates } from '../../../services/monthlyAttendanceService';
import { getBlockList, getBlocksBasedOnsubId, getGodownListByBlockId, getsubdivisionsBasedonDid, updateBlockService, updatetheGodowns } from '../../../services/godownLatLongService';
import { capitalizeFirstLetter, isAlphabet, isDigit } from '../../../utils/validations';
import './UpdateBlockForGodown.css';
import { useNavigate } from 'react-router-dom';


const UpdateBlockForGodown = () => {
    const [state, setState] = useState(3);
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [districtId, setDistrictId] = useState(null);
    const [subDivisionOptions, setSubDivisionOptions] = useState([]);
    const [subDivisionId, setSubDivisionId] = useState(null);
    const [blockOptions, setBlocksOptions] = useState([]);
    const [blockId, setBlockId] = useState(null);
    const [godownData, setGodownData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [updatingGodownId, setUpdatingGodownId] = useState(null);
    const [tempLat, setTempLat] = useState('');
    const [tempLong, setTempLong] = useState('');
    const navigate = useNavigate();
    const [editingBlockId, setEditingBlockId] = useState(null); // Track which row is being edited
    const [editPayload, setEditPayload] = useState({
        blockName: '',
        blockUid: '',
        subDivisionId: ''
    });
    // Fetch Districts
    useEffect(() => {
        const fetchStates = async () => {
            try {
                const res = await getStates();
                setStateOptions(res.map(item => ({
                    value: item.id,
                    label: capitalizeFirstLetter(item.stateName)
                })));
            } catch (err) {
                console.error('Error fetching states:', err);
            }
        };

        fetchStates();
    }, []);

    // Fetch Districts
    useEffect(() => {
        const fetchDistricts = async () => {
            if (state) {
                try {
                    const data = await getDistrict(state);
                    const formattedOptions = data.map(item => ({
                        value: item.districtId,
                        label: item.districtName,
                    }));
                    setDistrictOptions(formattedOptions);

                } catch (err) {
                    console.error('Error fetching districts:', err);
                }
            }
        };
        fetchDistricts();
    }, [state]);


    // Fetch Subdivisions
    useEffect(() => {
        const fetchSubdivisions = async () => {
            if (!districtId) {
                setSubDivisionOptions([]);
                return;
            }
            try {
                const data = await getsubdivisionsBasedonDid(districtId);
                setSubDivisionOptions(data.map(sub => ({
                    value: sub.id,
                    label: capitalizeFirstLetter(sub.subDivisionName)
                })));
            } catch (err) {
                console.error('Error fetching Subdivisions:', err);
            }
        };
        fetchSubdivisions();
    }, [districtId]);

    // Fetch Blocks
    useEffect(() => {
        const fetchBlocks = async () => {
            if (!subDivisionId) {
                setBlocksOptions([]);
                return;
            }
            try {
                const data = await getBlocksBasedOnsubId(subDivisionId);
                setBlocksOptions(data.map(blo => ({
                    value: blo.id,
                    label: capitalizeFirstLetter(blo.blockName)
                })));
            } catch (error) {
                console.error('Error fetching Blocks:', error);
            }
        };
        fetchBlocks();
    }, [subDivisionId]);

    const fetchGodownTable = async (districtId, subDivisionId) => {
        if (!districtId, !subDivisionId) return;
        setLoading(true);
        try {
            const data = await getBlockList(districtId, subDivisionId);
            setGodownData(data || []);
        } catch (error) {
            console.error('Error fetching godown list:', error);
            alert("Failed to fetch godown list.");
            setGodownData([]);
        } finally {
            setLoading(false);
        }
    };

    const handleFetch = () => {
        if (!districtId, !subDivisionId) {
            alert("Please select a district and block first!");
            return;
        }
        fetchGodownTable(districtId, subDivisionId);
    };

    const handleReset = () => {
        setDistrictId(null);
        setSubDivisionId(null);
        setBlockId(null);
        setGodownData([]);
        setUpdatingGodownId(null);
    };

    // Start Editing Lat/Long
    const handleUpdateClick = (godown) => {
        setUpdatingGodownId(godown.godownId);
        setTempLat(godown.latitude || '');
        setTempLong(godown.longitude || '');
    };

    // Save Updated Location (PATCH)


    const gotoCreationLatLong = () => {
        navigate("/createBlock")
    }
    // 1. Initialize the edit form when "Update" is clicked
    const handleEditClick = (block) => {
        setEditingBlockId(block.id); // Assuming 'id' is the primary key for the API URL
        setEditPayload({
            blockName: block.blockName || '',
            blockUid: block.blockUid || '',
            subDivisionId: subDivisionId // Current subdivision context
        });
    };

    // 2. Handle input changes in the table
  const handleTableInputChange = (e) => {
    const { name, value } = e.target;

    // 1. Validation for Block UID: Only positive integers (0-9)
    if (name === 'blockUid') {
        // Regex: Allows only digits. Empty string allowed for backspacing.
        if (!isDigit(value)) {
            return; 
        }
    }

    // 2. Validation for Block Name: Only Alphabets and Spaces
    if (name === 'blockName') {
        // Regex: Allows a-z, A-Z, and spaces. Empty string allowed for backspacing.
        if (!isAlphabet(value)) {
            return;
        }
    }

    // Update the state
    setEditPayload(prev => ({
        ...prev,
        [name]: name === 'blockUid' ? value : value // Keep as string while typing for better UX
    }));
};

    // 3. Save the payload to the server
    const handleUpdateBlock = async (id) => {
        if (!editPayload.blockName || !editPayload.blockUid) {
            alert("Block Name and UID are required!");
            return;
        }

        try {
            setLoading(true);
            // Payload structure as per your requirement
            const payload = {
                blockUid: editPayload.blockUid,
                blockName: editPayload.blockName,
                subDivisionId: parseInt(editPayload.subDivisionId)
            };

            // Replace with your actual service call
            // await axios.put(`http://localhost:8080/api/blocks/${id}`, payload);
            const response = await updateBlockService(id, payload);

            console.log("Sending Payload:", payload);
            alert(`Block ${id} updated successfully!`);

            setEditingBlockId(null);
            fetchGodownTable(districtId, subDivisionId); // Refresh table
        } catch (error) {
            console.error("Update failed:", error);
            alert("Failed to update block.");
        } finally {
            setLoading(false);
        }
    };
    const handleStateChange = (selectedOption) => {
        setState(selectedOption ? selectedOption.value : null);
        setDistrictId(null);
        setSubDivisionId(null);
        setBlockId(null);
        setGodownData([]); // Clear the table
    };

    const handleDistrictChange = (selectedOption) => {
        setDistrictId(selectedOption ? selectedOption.value : null);
        setSubDivisionId(null); // Clear Subdivision when District changes
        setBlockId(null);       // Clear Block when District changes
        setGodownData([]);      // Clear table data
    };

    const handleSubDivisionChange = (selectedOption) => {
        setSubDivisionId(selectedOption ? selectedOption.value : null);
        setBlockId(null);       // Clear Block when Subdivision changes
        setGodownData([]);      // Clear table data
    };

    return (
        <div className="block-container-update">
            <div className="form-card-update">
                <h2 className="form-title-update">Update Block</h2>
                {/* <div className='navigate-btn'>
                    <button type='button' className='godown-btn-navigate' onClick={gotoCreationLatLong}>Add Block</button>
                </div> */}
                <div className="form-grid-update">
                    <div className="block-update">
                        <div className={`custom-select-update ${state ? 'has-value' : ''}`}>
                            <Select
                                classNamePrefix="select-update"
                                placeholder=" "
                                isClearable
                                options={stateOptions}
                                value={stateOptions.find(opt => opt.value === state) || null}
                                onChange={handleStateChange}
                            />
                        </div>
                        <label><span className="reqiured">*</span> State</label>
                    </div>
                    <div className="block-update">
                        <div className={`custom-select-update ${districtId ? 'has-value' : ''}`}>
                            <Select
                                classNamePrefix="select-update"
                                placeholder=" "
                                isClearable
                                options={districtOptions}
                                value={districtOptions.find(opt => opt.value === districtId) || null}
                                onChange={handleDistrictChange} // Updated
                            />
                        </div>
                        <label><span className="reqiured">*</span> District</label>
                    </div>

                    <div className="block-update">
                        <div className={`custom-select-update ${subDivisionId ? 'has-value' : ''}`}>
                            <Select
                                classNamePrefix="select-update"
                                placeholder=" "
                                isClearable
                                options={subDivisionOptions}
                                value={subDivisionOptions.find(opt => opt.value === subDivisionId) || null}
                                onChange={handleSubDivisionChange} // Updated
                            />
                        </div>
                        <label><span className="reqiured">*</span> Sub Division</label>
                    </div>

                    {/* <div className="block-update">
                        <div className={`custom-select-update ${blockId ? 'has-value' : ''}`}>
                            <Select
                                classNamePrefix="select-update"
                                placeholder=" "
                                isClearable
                                options={blockOptions}
                                value={blockOptions.find(opt => opt.value === blockId) || null}
                                onChange={(opt) => setBlockId(opt?.value || null)}
                            />
                        </div>
                        <label><span className="reqiured">*</span> Block</label>
                    </div> */}

                    <div className="block-update">
                        <div className="button-group-lat-update">
                            <button
                                className="btn btn-primary-lat-update"
                                onClick={handleFetch}
                                disabled={loading || !subDivisionId}
                            >
                                {loading ? 'Fetching...' : 'Fetch Blocks'}
                            </button>
                            <button
                                className="btn btn-secondary-lat-update"
                                onClick={handleReset}
                            >
                                Reset
                            </button>
                        </div>
                    </div>
                </div>

                {/* Godown Table */}

            </div>
            <div>
                {godownData.length > 0 && (
                    <div style={{ marginTop: '2.5rem' }}>
                        <h3>Block List</h3>
                        <table className="godown-table">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>District Name</th>
                                    <th>SubDivision Name</th>
                                    <th>Block ID</th>
                                    <th>Block Name</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {godownData.map((godown, index) => (
                                    <tr key={godown.id || index}>
                                        <td>{index + 1}</td>
                                        <td>{godown.districtName || 'N/A'}</td>
                                        <td>{capitalizeFirstLetter(godown.subDivisionName) || 'N/A'}</td>
                                        {/* Block ID / UID Column */}
                                        <td>
                                            {editingBlockId === godown.id ? (
                                                <input
                                                    type="text"
                                                    name="blockUid"
                                                    className="table-input-edit"
                                                    value={editPayload.blockUid}
                                                    onChange={handleTableInputChange}
                                                />
                                            ) : (
                                                godown.blockUid || 'N/A'
                                            )}
                                        </td>
                                        {/* Block Name Column */}
                                        <td>
                                            {editingBlockId === godown.id ? (
                                                <input
                                                    type="text"
                                                    name="blockName"
                                                    className="table-input-edit"
                                                    value={editPayload.blockName}
                                                    onChange={handleTableInputChange}
                                                />
                                            ) : (
                                                godown.blockName || 'N/A'
                                            )}
                                        </td>

                                        {/* Action Buttons */}
                                        <td>
                                            {editingBlockId === godown.id ? (
                                                <div className="action-buttons-flex">
                                                    <button
                                                        className="btn btn-primary-lat-update"
                                                        onClick={() => handleUpdateBlock(godown.id)}
                                                        disabled={loading}
                                                    >
                                                        {loading ? '...' : 'Save'}
                                                    </button>
                                                    <button
                                                        className="btn btn-secondary-lat-update"
                                                        onClick={() => setEditingBlockId(null)}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            ) : (
                                                <button
                                                    className="btn btn-primary-lat-update"
                                                    onClick={() => handleEditClick(godown)}
                                                >
                                                    Edit Block
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

                {godownData.length === 0 && blockId && !loading && (
                    <p style={{ textAlign: 'center', marginTop: '2rem', color: '#666' }}>
                        No godowns found for the selected block.
                    </p>
                )}
            </div>

        </div>
    );
};

export default UpdateBlockForGodown;